import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { parseScore, formatScoreVisual } from '../../utils/scores';

/**
 * Score for on-screen matchups. Isolated as LTR so digits do not bidi-flip,
 * and swapped in Hebrew so the left number matches the left (away) team.
 */
export function ScoreText({ score, className = '' }) {
  const { isRTL, language } = useLanguage();
  const parsed = parseScore(score);
  if (!parsed) {
    return (
      <span className={className} aria-hidden>
        —
      </span>
    );
  }

  const ariaLabel =
    language === 'en'
      ? `Home ${parsed.homeScore}, away ${parsed.awayScore}`
      : `בית ${parsed.homeScore}, חוץ ${parsed.awayScore}`;

  return (
    <span
      dir="ltr"
      translate="no"
      className={`inline-block font-mono tabular-nums ${className}`.trim()}
      aria-label={ariaLabel}
    >
      {formatScoreVisual(score, isRTL)}
    </span>
  );
}
